import { render, staticRenderFns } from "./section-wise-report.vue?vue&type=template&id=6bbf864a&scoped=true&"
import script from "./section-wise-report.vue?vue&type=script&lang=js&"
export * from "./section-wise-report.vue?vue&type=script&lang=js&"
import style0 from "./section-wise-report.vue?vue&type=style&index=0&id=6bbf864a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf864a",
  null
  
)

export default component.exports